/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: -EsDm7v023

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicTextWithInfo.module.css"; // plasmic-import: -EsDm7v023/css

import InformationSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__InformationSvg"; // plasmic-import: hqBNVBJWB/icon

createPlasmicElementProxy;

export type PlasmicTextWithInfo__VariantMembers = {
  medium: "medium";
};
export type PlasmicTextWithInfo__VariantsArgs = {
  medium?: SingleBooleanChoiceArg<"medium">;
};
type VariantPropType = keyof PlasmicTextWithInfo__VariantsArgs;
export const PlasmicTextWithInfo__VariantProps = new Array<VariantPropType>(
  "medium"
);

export type PlasmicTextWithInfo__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicTextWithInfo__ArgsType;
export const PlasmicTextWithInfo__ArgProps = new Array<ArgPropType>("children");

export type PlasmicTextWithInfo__OverridesType = {
  root?: Flex__<"div">;
  icon?: Flex__<"svg">;
};

export interface DefaultTextWithInfoProps {
  children?: React.ReactNode;
  medium?: SingleBooleanChoiceArg<"medium">;
  className?: string;
}

const $$ = {};

function PlasmicTextWithInfo__RenderFunc(props: {
  variants: PlasmicTextWithInfo__VariantsArgs;
  args: PlasmicTextWithInfo__ArgsType;
  overrides: PlasmicTextWithInfo__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "medium",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.medium,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootmedium]: hasVariant($state, "medium", "medium") }
      )}
    >
      {renderPlasmicSlot({
        defaultContents: "Enter some text",
        value: args.children,
      })}
      <InformationSvgIcon
        data-plasmic-name={"icon"}
        data-plasmic-override={overrides.icon}
        className={classNames(projectcss.all, sty.icon, {
          [sty.iconmedium]: hasVariant($state, "medium", "medium"),
        })}
        role={"img"}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "icon"],
  icon: ["icon"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  icon: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTextWithInfo__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTextWithInfo__VariantsArgs;
    args?: PlasmicTextWithInfo__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicTextWithInfo__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTextWithInfo__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTextWithInfo__ArgProps,
          internalVariantPropNames: PlasmicTextWithInfo__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicTextWithInfo__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTextWithInfo";
  } else {
    func.displayName = `PlasmicTextWithInfo.${nodeName}`;
  }
  return func;
}

export const PlasmicTextWithInfo = Object.assign(
  // Top-level PlasmicTextWithInfo renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    icon: makeNodeComponent("icon"),

    // Metadata about props expected for PlasmicTextWithInfo
    internalVariantProps: PlasmicTextWithInfo__VariantProps,
    internalArgProps: PlasmicTextWithInfo__ArgProps,
  }
);

export default PlasmicTextWithInfo;
/* prettier-ignore-end */
